export interface ANCPReportValue {
  id: string;
  value: string;
}

interface ANCPReportProps {
  [key: string]: ANCPReportValue
}

export const ancpReport: ANCPReportProps = {
  CADASTRO: {
    id: 'cadastros',
    value: 'Cadastro',
  },
  PESOS: {
    id: 'pesos',
    value: 'Pesos',
  },
}

export const ancpReportOptions = Object.keys(ancpReport).map((key: string) => ancpReport[key])
